import React, { useEffect, useRef } from 'react';
import { gsap, Sine } from "gsap";
import { Application, Graphics } from 'pixi.js-legacy';
import { ChallengeDemoConfig } from "../../models/Types";
import ChallengeUtils from '../challenges/ChallengeUtils';
import { useTranslation } from 'react-i18next';
import { isDarkModeEnabled } from "../Util";

const BG_COLOR_DARK = 0x1C1B23;
const BG_COLOR_LIGHT = 0xffffff;
const ARC_COLOR_LIGHT = 0xecf0f1;
const ARC_COLOR_DARK = 0xecf0f1;

export default function Challenge1DDemo(props: ChallengeDemoConfig) {

  const challengeRef = useRef<any>(null);
  const { t } = useTranslation();

  const GEOMETRY = [
    { radius: 25, stroke: 4, startAngle: Math.PI * 0.18, endAngle: Math.PI * 0.6 },
    { radius: 50, stroke: 4, startAngle: Math.PI * 0.78, endAngle: Math.PI * 0.9 },
    { radius: 30, stroke: 2, startAngle: Math.PI * 0.98, endAngle: Math.PI * 0.1 },
    { radius: 40, stroke: 2, startAngle: Math.PI * 0.58, endAngle: Math.PI * 0.75 },
    { radius: 35, stroke: 2, startAngle: Math.PI * 0.28, endAngle: Math.PI * 0.75 },
    { radius: 35, stroke: 2, startAngle: -0.1, endAngle: 0.6 },
    { radius: 35, stroke: 3, startAngle: 3.5, endAngle: -1.51 },
    { radius: 45, stroke: 1, startAngle: -0.81, endAngle: -0.1 },
    { radius: 50, stroke: 2, startAngle: 3.6, endAngle: -0.6 },
    { radius: 75, stroke: 3, startAngle: -0.9, endAngle: 0 },
    { radius: 70, stroke: 2, startAngle: 1.5, endAngle: 2.9 }];

  function drawBeam(color: number) {
    const beam = new Graphics();
    beam.beginFill(color);
    beam.drawRect(0, 0, 15, 7);
    beam.endFill();
    beam.x = 0;
    beam.y = props.height / 2;

    return beam;
  }

  function drawDemoView() {
    const view = challengeRef.current;

    if ((view && view.children.length === 0)) {

      const isDark = isDarkModeEnabled();
      const backgroundColor = isDark ? BG_COLOR_DARK : BG_COLOR_LIGHT;
      const application: Application = ChallengeUtils.generateApplication({
        width: props.width,
        height: props.height,
        backgroundColor
      });

      view.appendChild(application.view);

      const width = props.width;
      const height = props.height;
      const middleWidth = width / 2;
      const middleVertical = height / 2;

      GEOMETRY.forEach((geom) => {
        const geomObj = new Graphics();
        ChallengeUtils.drawArc(
          geomObj,
          middleWidth,
          middleVertical,
          geom.radius,
          geom.stroke,
          isDark ? ARC_COLOR_DARK : ARC_COLOR_LIGHT,
          geom.startAngle,
          geom.endAngle
        );
        application.stage.addChild(geomObj);
      })

      const beam1 = drawBeam(0x6D4AFF)
      const beam2 = drawBeam(0x6D4AFF)
      beam2.x = props.width - 15;
      beam2.y = props.height - 10;

      application.stage.addChild(beam1);
      application.stage.addChild(beam2);

      gsap.to(beam2, {
        y: props.height / 2,
        ease: Sine.easeIn,
        duration: 1.5,
        repeatDelay: 1.5,
        repeat: -1,
        yoyo: true
      })
    }
  }

  useEffect(() => {
    drawDemoView()
  }, [challengeRef]);

  return (
    <div>
      <div ref={challengeRef} className="challenge-canvas-demo-1d"/>
      <h2 className="challenge-canvas-demo-heading">{t('BeamAlignmentChallengeHeader.text')}</h2>
      <p>{t('BeamAlignmentChallengeInfo.text')}</p>

    </div>
  )
}